import { ComponentsModule } from '../../../../shared/components/components.module';
import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';
import { SellionsLayoutRendererLibModule } from '../../../../submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/public-api';
import { SuperTabsModule } from 'ionic2-super-tabs';
import { UserTaskAssignedListModule } from './user-task-assigned-list/user-task-assigned-list.module';
import { UserTaskClosedListModule } from './user-task-closed-list/user-task-closed-list.module';
import { UserTaskListPage } from './user-task-list';
import { UserTaskNewListModule } from './user-task-new-list/user-task-new-list.module';

@NgModule({
  declarations: [UserTaskListPage],
  imports: [
    SellionsLayoutRendererLibModule,
    IonicPageModule.forChild(UserTaskListPage),
    ComponentsModule,
    SuperTabsModule.forRoot(),
    UserTaskNewListModule,
    UserTaskAssignedListModule,
    UserTaskClosedListModule,
  ],
})
export class UserTaskListModule {}



// WEBPACK FOOTER //
// ./src/modules/user-tasks/pages/user-task-list/user-task-list.module.ts